import React, { Component } from "react";
import MetaTags from "react-meta-tags";

class ReturnPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="wrapper">
        <MetaTags>
          <title>Return, Refund & Cancellation Policy</title>
          <meta
            id="description"
            name="mg-description"
            content="Return, Refund & Cancellation Policy In Shopperr."
          />
          <meta
            id="keywords"
            property="mg-keyword"
            content="head,body,html,tags"
          />
        </MetaTags>
        <div className="container">
          {" "}
          <div className="row">
            <div className="col-lg-12">
              
              <h2
                className="font-weight-normal text-7 mb-2"
                style={{ textAlign: "center", marginTop: "10px" }}
              >
                <strong className="font-weight-extra-bold">
                  Return, Refund & Cancellation Policy
                </strong>
              </h2>
              <strong>Last Updated: 18th Oct 2024</strong>
              <br/>
              <br/>
              <strong>Return/Refund Payment</strong>
             
              <li>
              At https://dropship.shopperr.in/, we strive to offer high-quality products and a seamless shopping experience. However, if you are not completely satisfied with your purchase, our returns, refund, and cancellation policy ensures you have options. Please read the terms below carefully to understand how returns, refunds, and cancellations are handled.

 
              </li>

              <strong>Return Policy</strong>

              <li>We offer a 7 days return window on most products from the date of delivery. To qualify for a return, please ensure the following:.</li>
              <strong>Conditions for Return:</strong>
              <ul> 
              <li> The item must be unused, in its original packaging, with all tags and labels intact.</li>
              <li> Certain products, such as perishable goods, intimate items, and customized products, are non-returnable. Please refer to the product description page for specific details.</li>
              <li> Items damaged due to misuse or improper handling are not eligible for return.</li>
              <li> Only items that are damaged, defective or incorrect would be eligible for returns. Since items are sourced from overseas destinations based on your order, we wont be able to entertain requests for returns for any other reasons. </li>
              </ul>
              <strong>How to Initiate a Return:</strong>
<ul> 
              <li> To initiate a return, please contact our customer support team at <b> support@shopperr.in</b> within 7 days of receiving the product.</li>
              <li> Provide your order number, details of the product, and the reason for return.</li>
              <li> Upon approval, we will send you a return shipping label, or guide you on how to return the product. Shipping charges may apply.</li>
              </ul>
              <strong>Return Shipping:</strong>

              <li> Returns are accepted within 7 days from date of purchase. If the return is due to our error (e.g., wrong item shipped, defective product), we will cover the cost of return shipping.</li>
              
             
              
          
                    <strong>Refund Policy</strong>

                    <li> Refund will be processed & credited in 2-5 working days. Once we receive the returned product, we will inspect it to ensure it meets the return conditions. After the inspection, we will process your refund.</li>

                    <strong>Refund Process:</strong>
                    <ul> 
                    <li>
                      Approved refunds will be processed within 7 days after we receive and inspect the returned item.
                    </li>
                    <li>
                     Approved refunds will be processed within 7 days after we receive and inspect the returned item.
                    </li>
                    <li>
                     If applicable, any shipping charges incurred during the original purchase will not be refunded..
                    </li>
                    <li>
                    If you have opted for store credit instead of a refund, it will be applied to your account immediately upon approval.
                    </li>
                    </ul>

                    <strong> Non-Refundable Items:</strong>
                    <ul> 
                    <li>
                      Shipping fees and final sale items are not eligible for a refund.
                    </li>
                    <li>
                       Items that do not meet the return conditions (used, damaged, missing tags) will not be refunded.
                    </li>
                    </ul>

                <strong>Cancellation Policy</strong>
              <li>We understand that you may need to cancel your order. You can cancel your order as long as it hasn’t been shipped.</li>
              <strong>Cancellation Before Shipping:</strong>
              <ul>
                <li>Orders can be canceled free of charge if they have not yet been processed and shipped.</li>
                <li>To cancel, please contact customer support at <b> support@shopperr.in</b> with your order number.</li>
                <li>If your order is canceled before shipping, you will receive a full refund.</li>
              </ul>
              <strong>Cancellation After Shipping:</strong>
              <li>Once an order has been shipped, it cannot be canceled. In such cases, you will need to initiate a return after receiving the product.</li>

              <strong>Cancellation of Customized Orders:</strong>
              <li>Customized, personalized, or made-to-order products cannot be canceled once the order has been placed.</li>
              
              <strong>Exchange Policy</strong>
              <li>We currently do not offer direct exchanges. If you would like to exchange a product for a different size or color, please initiate a return and place a new order.</li>
              
              <strong>Damaged or Defective Products</strong>
              <li>Damaged and defective products replacement/exchanges will be processed with in 5-7 business days.</li>
              <strong>How to Report:</strong>
              <ul>
                <li>Send an email to <b>support@shopperr.in</b> with your order number, details of the defect, and supporting photos.</li>
                <li>We will provide a replacement or refund based on product availability and your preference.</li>
              </ul>
              
              {/* <strong>Non-Returnable and Non-Refundable Products</strong>
              <ul>
                <li>Perishable goods (e.g., food, flowers)</li>
                <li>Personal care products (e.g., cosmetics, hygiene products)</li>
                <li>Customized or personalized items</li>
                <li>Items marked as “Final Sale” on the product page</li>
                <li>Items under special discounts</li>    
              </ul> */}
              <li>Please check the product details for any specific return and refund restrictions before making a purchase.</li>
              
              <strong>Contact Us</strong>
              <li>If you have any questions or concerns about our Returns, Refund, and Cancellation Policy, feel free to reach out to our customer support team:</li>
              <ul>
                <li>Email:<b>  support@shopperr.in</b></li>
                <li>Business Hours: 10 am to 6 pm, Monday to Friday</li>
              </ul>
              <li>Thank you for shopping with <b> https://dropship.shopperr.in/</b> We are committed to providing you with the best possible customer experience.</li>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReturnPolicy;

